import { render } from "./HomeTestimonials.vue?vue&type=template&id=ff463f0c&scoped=true"
import script from "./HomeTestimonials.vue?vue&type=script&lang=js"
export * from "./HomeTestimonials.vue?vue&type=script&lang=js"

import "./HomeTestimonials.vue?vue&type=style&index=0&id=ff463f0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff463f0c"]])

export default __exports__